export const SIZE_5G = 5368709120;
export const SIZE_20M = 20971520;
